<!-- 产品详情 -->
<template>
    <div class="responsibility_c">
      <sub-banner id="id_about">
        <img src="../../assets/images/news/news_top.png"/>
      </sub-banner>
      <div class="product_d">
          <div class="product_title">
          <span>产品中心 </span>
           <span class="detail_small">> &nbsp;
             {{prdContent.name}}
           </span>
           
          </div>
      </div>
      <div class="product_content">
          <div class="product_detail">
              <div class="product_img">
                  <img :src="prdContent.mainImgUrl"/>
              </div>
              <div class="product_des">
                  <div class="title_des">{{prdContent.name}}</div>
                  <div class="abstract">
                      {{prdContent.briefIntroduction}}
                  </div>
                  <div class="consulting_service">
                      <div class="btn_price" @click="openPriceConsulting()">立即询盘</div>
                  </div>
              </div>
          </div>
      </div>
      <div class="content_prd" v-if="prdContent.detail">
          <div class="content_infos">
              <div  v-html="prdContent.detail"></div>
          </div>
      </div>
      
      <el-dialog title="" :visible.sync="dialogProductVisible" width="50%"  @close="closeProductDialog" >
          <div class="consulting_content">
              <div class="consulting_title">咨询内容</div>
              <div class="consulting_info">
                  <div class="prd_imgs">
                       <img :src="prdContent.mainImgUrl"/>
                  </div>
                  <div class="prd_title">{{prdContent.name}}</div>
              </div>

              <div class="consulting_form_title">咨询表单：</div>
              <div class="consulting_form">
                  <div class="consulting_item"><el-input v-model="consultingData.name" placeholder="请填写联系人："></el-input></div>
                  <div class="consulting_item"><el-input v-model="consultingData.phone" placeholder="请填写电话/邮箱："></el-input></div>
                  <div class="consulting_item"><el-input v-model="consultingData.consultingContent" placeholder="最多输入250字：" type="textarea" maxlength="250" :rows=4></el-input></div>
              </div>
              <div class="submit_btn" @click="submitClick">提交</div>
              <div class="consulting_phone">
                  <div class="phone_content">咨询电话：020-37247681</div>
              </div>
          </div>
      </el-dialog>
    </div>
</template>

<script>
import { concatMeta } from '@/config/metaJson.js'
import {getProductDetail,addConsultingProduct} from '../../service/service';
import SubBanner from "@/components/sub-banner";
export default {
  name: 'responsibility',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-产品详情',
      metaName:'广州市熵达贸易有限公司-产品详情',
      metaContent:'广州市熵达贸易有限公司-产品详情',
      keyword:'广州市熵达贸易有限公司,熵达贸易,熵达',
      description:'广州市熵达贸易有限公司' , 
      prdContent:{},
      dialogProductVisible:false,
      consultingData:{
          productId:0,
          productName:'',
          name:'',
          phone:'',
          consultingContent:'',
      }
    };
  },
  computed: {},
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  methods: {
      openPriceConsulting(){
          this.dialogProductVisible=true;
      },
      closeProductDialog(){
          this.dialogProductVisible=false;
      },
      submitClick(){
        if(!this.judgeIsEmpty(this.consultingData.name)){
           alert('姓名不能为空！');
           return ;
         }
        if(!this.judgeIsEmpty(this.consultingData.phone)){
           alert('联系方式不能为空！');
           return ;
        } 
        if(!this.judgeIsEmpty(this.consultingData.consultingContent)){
           alert('咨询内容不能为空！');
           return ;
        }
        this.addConsultingProduct();

     },
     judgeIsEmpty(val){
         if(val==''||val==undefined||val==null){
             return false;
         }else{
             return true;
         }
     },
     async getProductDetail(id){
         let resp=await getProductDetail(id)
         if(resp){
            resp.mainImgUrl=process.env.BASE_IMG_URL+resp.mainImgUrl;
             this.prdContent=resp;
             this.consultingData.productName=resp.name;
         }
     },
     async addConsultingProduct(){
         let resp=await addConsultingProduct(this.consultingData)
         if(resp&&resp>0){
              alert("提交成功,稍后我们将会联系您！");
         }else{
             alert("提交失败,错误："+resp.userTip)
         }
     }
  },
  created () {

  },
  mounted () {
      let id=this.$route.query.id;
      console.log(id,'id');
      this.consultingData.productId=id;
      this.getProductDetail(id)
  },
}
</script>
<style lang='scss' scoped>

.product_d{
    width:100%;
    background:#f8f8f8;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .product_title{
        width:70%;
        margin: auto;
        font-size: 24px;
        font-weight: bold;
        letter-spacing: 0px;
        color: #666666;
        text-align: left;
        .detail_small{
            font-size: 20px;
        }
    }
   

}

.product_content{
    width:100%;
    background:#ffffff;
    padding-top:62px;
    padding-bottom:70px;
    .product_detail{
        width:70%;
        margin:auto;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .product_img{
            width:400px;
            border:2px solid #f8f8f8;
            border-radius: 5px;
            padding:10px 10px;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .product_des{
            margin-top: 40px;
            margin-left:130px;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            .title_des{
                font-size: 22px;
                font-weight: bold;
                color:#333333;
                position: relative;

            }
            .title_des::after{
                content:" ";
                position:absolute;
                left:0;
                bottom:-10px;
                width:140%;
                height:2px;
                transform:scaleY(.8);
                background-color:#eeeeee;
            }
            .abstract{
                color:#999999;
                font-size: 18px;
                line-height: 31px;
                width: 500px;
                text-align: left;
                margin-top:18px;

            }
            .consulting_service{
                margin-top:40px;
                .btn_price{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color:#ffffff;
                    width: 125px;
                    height: 49px;
                    background-color: #4f7cbd;
                    border-radius: 25px;
                    font-size: 17px;
                    cursor: pointer;

                }
            }
        }
    }
}

 .content_prd{
        width:100%;
        background: #ffffff;
        margin-top:45px;
        .content_infos{
            width:70%;
            margin:auto;
            text-align: left;
        }
}


.consulting_content{
   text-align: left;
   padding:20px 40px;
    .consulting_title{
        color:#333333;
        font-size: 22px;
        letter-spacing: 2px;
        margin-bottom: 18px;
        font-weight: bold;
    }
    .consulting_info{
        background:#f8f8f8;
        padding:8px 8px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;

        margin-bottom: 40px;
        .prd_imgs{
            width:88px;
            height: 88px;
            background: #ffffff;
            border-radius: 2px;
            img{
                width:100%;
                height: 100%;
            }
        }
        .prd_title{
            font-size: 18px;
            font-weight: bold;
            color:#999999;
            margin-left:20px;
            margin-top: 10px;;
        }
    }
    .consulting_form_title{
        color:#333333;
        font-size: 22px;
        font-weight: bold;
        margin-bottom:14px;
    }
    .consulting_form{
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        .consulting_item{
            width: 100%;
            margin-bottom:16px ;
        }
    }
    .submit_btn{
        height: 40px;
        background-color: #4f7cbd;
        border-radius: 6px;
        color:#ffffff;
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;
    }
    .consulting_phone{
       
        margin-top:50px;
        width:100%;
        text-align: center;
        .phone_content{
            font-size: 16px;
            color:#333333;
            // font-weight: bold;
            letter-spacing: 1px;
            font-family: MicrosoftYaHei;

        }
    }
}
              


</style>




// WEBPACK FOOTER //
// src/view/product/detail.vue